import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/90 hover:shadow-md hover:shadow-primary/20",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/90 hover:shadow-md",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:shadow-md hover:shadow-destructive/20",
        outline: "text-foreground border-border hover:border-accent hover:text-accent",
        accent: "border-transparent bg-accent/15 text-accent hover:bg-accent/25",
        success: "border-transparent bg-accent/15 text-accent hover:bg-accent/25",
        premium: "border-accent/30 bg-gradient-to-r from-accent/10 to-accent/5 text-accent hover:border-accent/50 hover:shadow-sm hover:shadow-accent/10",
        glass: "border-border/30 bg-background/50 backdrop-blur-sm text-foreground hover:bg-background/70",
        glow: "border-transparent bg-accent text-accent-foreground shadow-sm shadow-accent/30 hover:shadow-md hover:shadow-accent/40",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
  }
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
